import React from "react";

export const Footer = (props) => {
    return (
        <div id="footer">
            <div className="container">
                <div className="row">
                    <div className="col-md-4 col-sm-6">
                        <div className="footer-about">
                            <a className="footer-logo page-scroll" href="#page-top" onClick={() => props.handleNavigate && props.handleNavigate("#page-top")}>
                                <img
                                    src="img/akriv-logo.svg"
                                    alt="Akriv"
                                    style={{ height: "50px", width: "auto" }}
                                />
                            </a>
                            <p>
                                <strong>Akriv Tech</strong>{props.data ? props.data.footerOverview : ""}
                            </p>

                            <div className="social">
                                <a
                                    href={props.data ? props.data.facebook : "/"}
                                    target="blank"
                                    title="Facebook"
                                >
                                    <i class="fa-brands fa-facebook-f"></i>
                                </a>
                                <a
                                    href={props.data ? props.data.linkedin : "/"}
                                    target="blank"
                                    title="LinkedIn"
                                >
                                    <i class="fa-brands fa-linkedin-in"></i>
                                </a>

                                <a
                                    href={props.data ? props.data.instagram : "/"}
                                    target="blank"
                                    title="Instagram"
                                >
                                    <i className="fa-brands fa-instagram"></i>
                                </a>
                                <a
                                    href={props.data ? props.data.threads : "/"}
                                    target="blank"
                                    title="Threads"
                                >
                                    <i className="fa-brands fa-threads"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7 col-sm-6 col-md-offset-1">
                        <div className="row">
                            <div className="col-md-5 col-sm-6">
                                <div className="footer-links">
                                    <h3>Services</h3>
                                    <ul>
                                        <li>
                                            <a href="#services" onClick={() => props.handleNavigate && props.handleNavigate("#services")}>Digital Transformation & Governance</a>
                                        </li>
                                        <li>
                                            <a href="#services" onClick={() => props.handleNavigate && props.handleNavigate("#services")}>ERP Consulting & Implementation</a>
                                        </li>
                                        <li>
                                            <a href="#services" onClick={() => props.handleNavigate && props.handleNavigate("#services")}>Web & Digital Experiences</a>
                                        </li>
                                        <li>
                                            <a href="#services" onClick={() => props.handleNavigate && props.handleNavigate("#services")}>Mobile Solutions</a>
                                        </li>
                                        <li>
                                            <a href="#services" onClick={() => props.handleNavigate && props.handleNavigate("#services")}>Secure API Architecture</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6">
                                <div className="footer-links">
                                    <h3>Company</h3>
                                    <ul>
                                        <li>
                                            <a href="#about" onClick={() => props.handleNavigate && props.handleNavigate("#about")}>About Us</a>
                                        </li>
                                        <li>
                                            <a href="#faq" onClick={() => props.handleNavigate && props.handleNavigate("#faq")}>FAQ</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6">
                                <div className="footer-links">
                                    <h3>Legal</h3>
                                    <ul>
                                        <li>
                                            <a href="#" onClick={(e) => { e.preventDefault(); props.setCurrentView("privacy"); }}>Privacy Policy</a>
                                        </li>
                                        <li>
                                            <a href="#" onClick={(e) => { e.preventDefault(); props.setCurrentView("terms"); }}>Terms & Conditions</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>
                        Copyright &copy; 2025 <strong>Akriv Tech.</strong> All rights reserved.
                    </p>
                </div>
            </div>
        </div>
    );
};
